module.exports = __webpack_public_path__ + "img/viettel.4552c1c2.png";